<p-dialog
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [header]="editingId ? 'Editar Publicação de Qualidade' : 'Nova Publicação de Qualidade'"
  [style]="{ width: '680px', maxWidth: 'calc(100vw - 2rem)' }"
  [breakpoints]="{ '768px': '95vw', '480px': '100vw' }">
  <div class="quality-form">
    <div class="grid p-fluid" [formGroup]="form">

      <div class="col-8">
        <div class="field-group">
          <span class="field-label">Status</span>
          <app-favorite-select
            formControlName="ticket_status_id"
            [options]="statuses()"
            optionLabel="description"
            optionValue="id"
            placeholder="Buscar status..."
            [filter]="true"
            (onFilter)="onStatusFilter($event)"
            [loading]="statusesLoading()"
            [emptyMessage]="statusesLoading() ? 'Buscando...' : 'Nenhum status encontrado'"
            [emptyFilterMessage]="statusesLoading() ? 'Buscando...' : 'Nenhum status encontrado'"
            [showClear]="true"
            appendTo="body"
            [favorites]="true"
            [favoritesKey]="FavoriteKey.TicketStatuses"
            class="w-full" />
        </div>
      </div>

      <div class="col-4">
        <div class="field-group">
          <span class="field-label">Data</span>
          <p-datepicker
            formControlName="data"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [showButtonBar]="true"
            appendTo="body"
            class="w-full" />
        </div>
      </div>

      <div class="col-8">
        <div class="field-group">
          <span class="field-label">Título</span>
          <input type="text" pInputText formControlName="titulo" placeholder="Título da publicação" class="w-full" />
        </div>
      </div>

      <div class="col-4">
        <div class="field-group">
          <span class="field-label">Responsável</span>
          <!-- Sem `filterBy`: com busca remota ele viraria um segundo filtro local, sobre o
               `name`, escondendo o que o back achou por login/e-mail/ref. -->
          <app-favorite-select
            formControlName="user_id"
            [options]="users()"
            optionLabel="name"
            optionValue="id"
            placeholder="Buscar responsável..."
            [filter]="true"
            (onFilter)="onUserFilter($event)"
            [loading]="usersLoading()"
            [emptyMessage]="usersLoading() ? 'Buscando...' : 'Nenhum usuário encontrado'"
            [emptyFilterMessage]="usersLoading() ? 'Buscando...' : 'Nenhum usuário encontrado'"
            [showClear]="true"
            appendTo="body"
            [favorites]="true"
            [favoritesKey]="FavoriteKey.TicketResponsibles"
            class="w-full" />
        </div>
      </div>

      <div class="col-12">
        <div class="field-group">
          <span class="field-label">Tags</span>
          <patron-chips [(values)]="tags" placeholder="Adicionar tags..." class="w-full" />
        </div>
      </div>

      <div class="col-12">
        <div class="field-group">
          <span class="field-label">Link</span>
          <input type="text" pInputText formControlName="link" placeholder="https://..." class="w-full" />
        </div>
      </div>

      <div class="col-12">
        <div class="field-group">
          <span class="field-label">Descrição</span>
          <textarea
            pTextarea
            formControlName="descricao"
            rows="9"
            placeholder="Descrição detalhada..."
            class="w-full"></textarea>
        </div>
      </div>

      <div class="col-12">
        <div class="check-inline">
          <p-checkbox
            [ngModel]="publicar()"
            [binary]="true"
            inputId="publicar-check"
            [ngModelOptions]="{ standalone: true }"
            (onChange)="publicar.set($event.checked)" />
          <label for="publicar-check">Publicar</label>
        </div>
      </div>

    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button
        label="Cancelar"
        severity="secondary"
        [outlined]="true"
        (onClick)="cancel()"
        [disabled]="saving()" />
      <p-button
        label="Salvar"
        severity="primary"
        [loading]="saving()"
        (onClick)="save()" />
    </div>
  </ng-template>
</p-dialog>
